<button
  #buttonRef
  class="flex items-center justify-center w-full gap-8 overflow-hidden h-fit fill-brand-700 text-body-md-400 text-brand-700 hover:bg-secondary-greys-30 hover:text-brand-700 active:bg-secondary-greys-30 active:fill-brand-800 active:text-brand-800 disabled:bg-transparent disabled:fill-secondary-greys-400 disabled:text-secondary-greys-400"
  (click)="buttonClicked.emit(true)"
  [disabled]="disabled()"
  [ngClass]="{
    'p-12': !ghost(),
    'p-4': ghost(),
    'bg-secondary-greys-white': !transparent(),
    'bg-transparent': transparent()
  }"
>
  @if (icon()) {
    <svg-icon [src]="icon()"></svg-icon>
  }
  {{ label() }}
</button>
